<template>
    <q-dialog v-model="showModal" persistent>
        <q-card v-if="license" style="width: 600px;">
            <q-card-section>
                <div class="text-h6 row items-center">
                    <q-icon name="mdi-lock-open-variant-outline" size="sm" class="q-mr-xs" />Activations
                    <q-space />
                    <q-btn v-if="!isAutoActivation" icon="mdi-close" flat round dense v-close-popup />
                </div>
            </q-card-section>

            <q-card-section v-if="!isAutoActivation" class="q-pt-none">
                <q-item v-if="license" class="bg-grey-3 rounded-borders">
                    <q-item-section top>
                        <q-item-label overline>{{ license.licenseKeyID }}</q-item-label>
                        <q-item-label caption>
                            {{ license.productDescription }}
                        </q-item-label>
                        <q-item-label caption v-if="license.oemName">
                            OEM: {{ license.oemName }}
                        </q-item-label>
                        <q-item-label caption>
                            Expiry: {{ license.expiry | date }}
                        </q-item-label>
                    </q-item-section>

                    <q-item-section side top>
                        <q-badge transparent v-if="getLicenseStatus(license.expiry)" color="positive">
                            Active
                        </q-badge>
                        <q-badge transparent v-else color="negative">
                            Expired
                        </q-badge>
                    </q-item-section>
                </q-item>
            </q-card-section>

            <q-card-section v-if="isAutoActivation" class="q-pt-none">
                <span class="text-caption">
                    {{ instructions }}
                </span>
            </q-card-section>

            <q-card-section class="q-pt-none">
                <div class="row q-col-gutter-sm">
                    <div v-for="activation in license.activations.filter(a => a.isCurrent)" :key="activation.id"
                         :class="{'col-xs-12 col-sm-6' : !isAutoActivation, 'col-6' : isAutoActivation}">
                        <q-card class="full-height">
                            <q-item class="full-height">
                                <q-item-section class="column justify-between">
                                    <div class="column justify-center items-center">
                                        <div class="q-mb-xs q-px-md rounded-borders" style="border: 4px solid #4b4b4b">
                                            <q-icon name="mdi-swap-vertical-circle" color="warning" size="4rem" />
                                        </div>
                                        <q-field dense stack-label borderless label-slot
                                                 hide-bottom-space
                                                 label-color="accent"
                                                 class="text-caption full-width">
                                            <template v-slot:label>
                                                <div class="full-width text-center">
                                                    <span>Computer</span>
                                                </div>
                                            </template>
                                            <template v-slot:control>
                                                <span class="full-width text-center text-weight-medium">{{ activation.computer }}</span>
                                            </template>
                                        </q-field>

                                        <q-field dense stack-label borderless label-slot
                                                 hide-bottom-space
                                                 label-color="accent"
                                                 class="text-caption full-width">
                                            <template v-slot:label>
                                                <div class="full-width text-center">
                                                    <span>Install ID</span>
                                                </div>
                                            </template>
                                            <template v-slot:control>
                                                <span class="full-width text-center text-weight-medium">{{ activation.installID }}</span>
                                            </template>
                                        </q-field>
                                    </div>
                                    <div class="row q-my-sm">
                                        <q-btn v-if="license.canActivate" size="sm" label="Replace" color="warning" icon="mdi-swap-vertical"
                                               class="full-width"
                                               @click="replaceActivation(activation)" />
                                    </div>
                                </q-item-section>
                            </q-item>
                        </q-card>
                    </div>
                    <div v-if="license.activations.filter(a => a.isCurrent).length == 1" :class="{'col-xs-12 col-sm-6' : !isAutoActivation, 'col-6' : isAutoActivation}">
                        <q-card class="full-height">
                            <q-item class="full-height">
                                <q-item-section class="column justify-between">
                                    <div class="text-caption column justify-center items-center">
                                        <div class="q-mb-sm q-px-md rounded-borders" style="border: 4px solid #4b4b4b">
                                            <q-icon name="mdi-plus-circle" color="positive" size="4rem" />
                                        </div>
                                        <span>Add a new activation to your license.</span>
                                    </div>
                                    <div class="row q-my-sm">
                                        <q-btn v-if="license.canActivate" size="sm" label="Add New" color="positive" icon="mdi-plus"
                                               class="full-width"
                                               @click="newActivation()" />
                                    </div>
                                </q-item-section>
                            </q-item>
                        </q-card>
                    </div>
                </div>
            </q-card-section>
            <q-card-section v-if="!isAutoActivation" class="q-pt-none">
                <span class="text-caption">
                    <span class="text-weight-medium">DISCLAIMER:</span> {{ disclaimer }}
                </span>
            </q-card-section>
        </q-card>
    </q-dialog>
</template>
<script>
    export default {
        name: 'dialog-activations',
        props: {
            isAutoActivation: {
                type: Boolean,
                default: false
            },
            license: Object,
            show: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                disclaimer: 'This software license is for a single user only, and cannot be shared. Secondary activations are available to you at no charge so that you can use the software on two different computers (i.e work and home or laptop computer). If the second activation is intended for a different user then you cannot use the "Secondary Activation" available here and instead you will need to purchase a new license for the other user.',
                instructions: 'To activate this computer, choose "Replace" to replace your existing activation, or "Add New" if you still use the existing activation. You can have up to two computers activated for this software provided both are for your use exclusively.'
            }
        },
        methods: {
            replaceActivation(activation) {
                this.showModal = false
                this.$emit('replace', activation)
            },
            newActivation() {
                this.showModal = false
                this.$emit('activate', this.license)
            },
        },
        computed: {
            showModal: {
                get() {
                    return this.show
                },
                set(value) {
                    this.$emit('update:show', value)
                }
            },
        },
    }
</script>
